import { revenuePaymentFilterActions } from '../constants/filter';
import { asyncAction } from './common';
import {
  executeComposeRevenueQueries,
  executeRevenueQueries,
  executeRevenueQueryCsv,
} from '../api/revenue';

export const setRevenueType = (queryType) => ({
  type: 'CHANGE_REVENUE_QUERY_TYPE',
  queryType,
});

export const setRevenueGroupColumn = (groupColumn) => ({
  type: 'REVENUE_COMPOSE_SET_GROUP_COLUMN',
  groupColumn,
});

export const setRevenueColumnChartSorting = (sorting) => ({
  type: 'CHANGE_REVENUE_COLUMN_CHART_SORTING',
  sorting,
});

export const setRevenueSplitColumn = (splitColumn) => ({
  type: 'REVENUE_COMPOSE_SET_SPLIT_COLUMN',
  splitColumn,
});

export const assignTypeQuery = (queryType) => ({
  type: 'ASSIGN_REVENUE_TYPE_QUERY',
  queryType,
});

export const addFilterClause = () => ({
  type: revenuePaymentFilterActions.ADD_FILTER_CLAUSE,
});

export const removeFilterClause = (id) => ({
  type: revenuePaymentFilterActions.REMOVE_FILTER_CLAUSE,
  id,
});

export const removeFilter = (id) => ({
  type: revenuePaymentFilterActions.REMOVE_FILTER,
  id,
});

export const setFilterClauseField = (id, field, type) => ({
  type: revenuePaymentFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  fieldType: type,
});

export const setFilterClauseValue = (id, value) => ({
  type: revenuePaymentFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
});

export const setClausesConcatOperator = (value) => ({
  type: revenuePaymentFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
});

export const setFilterClauseOperator = (id, value, resetClauseValue) => ({
  type: revenuePaymentFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
});

export const changeRevenueView = (view) => ({
  type: 'CHANGE_REVENUE_VIEW',
  view,
});

export const setAmountField = (amountField) => ({
  type: 'SET_AMOUNT_FIELD',
  amountField,
});

export const toggleRevenueCalcTotal = () => ({
  type: 'TOGGLE_REVENUE_CALC_TOTAL',
});

export const toggleRevenueTrendLine = () => ({
  type: 'TOGGLE_REVENUE_TREND_LINE',
});

export const toggleRevenueAverageLine = () => ({
  type: 'TOGGLE_REVENUE_AVERAGE_LINE',
});

export const toggleRevenueMedianLine = () => ({
  type: 'TOGGLE_REVENUE_MEDIAN_LINE',
});

export const toggleRevenueAdaptive = () => ({
  type: 'TOGGLE_REVENUE_ADAPTIVE',
});

export const setRevenueExecuteId = (executeId) => ({
  type: 'SET_REVENUE_EXECUTE_ID',
  executeId,
});

export const executeRevenue = (executeId) =>
  asyncAction('EXECUTE_REVENUE_QUERIES', executeRevenueQueries(executeId));

export const executeComposeRevenue = (executeId) =>
  asyncAction('EXECUTE_REVENUE_QUERIES', executeComposeRevenueQueries(executeId));

export const executeRevenueCsv = () =>
  asyncAction('EXECUTE_EVENT_REVENUE_QUERY_CSV', executeRevenueQueryCsv());
